export const sectorsData = [
  {
    codigo_sector: 'SECTP_RESID',
    tipo_sector: 'RESIDENCIAL',
  },
  {
    codigo_sector: 'SECTP_COMER',
    tipo_sector: 'COMERCIAL',
  },
  {
    codigo_sector: 'SECTP_INDUST',
    tipo_sector: 'INDUSTRIAL',
  },
  {
    codigo_sector: 'SECTP_GNVC',
    tipo_sector: 'GAS NATURAL VEHICULAR',
  },
  {
    codigo_sector: 'SECTP_ELECGEN',
    tipo_sector: 'PLANTAS DE GENERACIÓN TERMICA',
  },
  {
    codigo_sector: 'SECTP_REFIN',
    tipo_sector: 'REFINERIA',
  },
  {
    codigo_sector: 'SECTP_GASTRANS',
    tipo_sector: 'GAS PARA TRANSPORTADORES',
  },
  {
    codigo_sector: 'SECTP_PETRO',
    tipo_sector: 'PETROQUIMICA',
  },
];
